export const getTimeZoneOffset = (date, timeZone) => {
  let iso = date.toLocaleString('en-CA', { timeZone, hour12: false }).replace(', ', 'T')
  iso += '.' + date.getMilliseconds()
  const lieUTC = `${iso.padStart(3, '0')}Z`

  const lie = new Date(Date.parse(lieUTC))
  return -(lie - date)
}
